<template>
  <div>
    <div class="name-info-title">
      {{ nombreCompleto }} <b>&#40;{{ pasajeros }} Pax&#41;</b>
    </div>
    <div class="mail-info-subtitle">
      <a :href="'mailto:' + correo">{{ correo }}</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ClientInfo',
  props: {
    nombre: {
      type: String,
      default: '',
    },
    apellidos: {
      type: String,
      default: '',
    },
    correo: {
      type: String,
      default: '',
    },
    pasajeros: {
      type: Number,
      default: undefined,
    },
  },
  computed: {
    nombreCompleto() {
      return this.nombre + ' ' + this.apellidos
    },
    // correoE() {
    //   return this.correo
    // },
  },
}
</script>

<style lang="scss" scoped>
.name-info-title {
  font-size: 0.8rem;
}
.mail-info-subtitle {
  font-size: 0.6rem;
}

.cel-info-subtitle {
  font-size: 0.7rem;
}
</style>
